var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_1332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7 15.3L23 12L19.7 8.7V4.3H15.3L12 1L8.7 4.3H4.3V8.7L1 12L4.3 15.3V19.7H8.7L12 23L15.3 19.7H19.7V15.3Z",
    stroke: "#306BF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8L9 15",
    stroke: "#306BF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8C9.79667 8 10.0867 8.08797 10.3334 8.2528C10.58 8.41762 10.7723 8.65189 10.8858 8.92597C10.9994 9.20006 11.0291 9.50166 10.9712 9.79264C10.9133 10.0836 10.7704 10.3509 10.5607 10.5607C10.3509 10.7704 10.0836 10.9133 9.79264 10.9712C9.50166 11.0291 9.20006 10.9994 8.92597 10.8858C8.65189 10.7723 8.41762 10.58 8.2528 10.3334C8.08797 10.0867 8 9.79667 8 9.5C8 9.10217 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10217 8 9.5 8Z",
    fill: "#306BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13C14.7967 13 15.0867 13.088 15.3334 13.2528C15.58 13.4176 15.7723 13.6519 15.8858 13.926C15.9994 14.2001 16.0291 14.5017 15.9712 14.7926C15.9133 15.0836 15.7704 15.3509 15.5607 15.5607C15.3509 15.7704 15.0836 15.9133 14.7926 15.9712C14.5017 16.0291 14.2001 15.9994 13.926 15.8858C13.6519 15.7723 13.4176 15.58 13.2528 15.3334C13.088 15.0867 13 14.7967 13 14.5C13 14.1022 13.158 13.7206 13.4393 13.4393C13.7206 13.158 14.1022 13 14.5 13Z",
    fill: "#306BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_1332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.78ed0778db3e570170b518987b02718d.svg";
export { ForwardRef as ReactComponent };